/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Microsoftgroupdata2Inputs */



/**

* @param {_Field_Microsoftgroupdata2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_microsoftgroupdata2 = /** @type {((inputs?: _Field_Microsoftgroupdata2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Microsoftgroupdata2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Microsoft Daten")
});
export { _field_microsoftgroupdata2 as "_field_microsoftGroupData" }